import React from 'react'

import './admin-popup.scss'
import { ReactComponent as XIcon } from "assets/img/close.svg"
import AdminMemberDetails from 'containers/AdminMemberDetails/AdminMemberDetails';
import { activeMemberIDAtom, memberDetailsProfilePopupAtom } from 'showMessageMenuAtom';
import { useAtom } from 'jotai';
import ReactModal from 'react-modal';

const AdminMemberDetailsPopUp = ({ group, getCommunityQuery }: { group: any, getCommunityQuery: any }) => {
  const [activeMemberID,] = useAtom(activeMemberIDAtom);
  const [isOpenmemberDetailsProfilePopup, setOpenmemberDetailsProfilePopup] = useAtom(memberDetailsProfilePopupAtom);

  return (
    <ReactModal
      isOpen={isOpenmemberDetailsProfilePopup}
      className='people-details-popup'
      style={{
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 2147483646,
        }
      }}
    >
      <div className="people-details-popup-header">
        <span
          onClick={() => setOpenmemberDetailsProfilePopup(false)}
          className='icon'
          style={{
            display: 'flex',
            cursor: 'pointer',
            color: '#333',
            width: '24px',
            height: '24px',
          }}
        >

          <XIcon />
        </span>
      </div>
      <div className="people-details-popup-body" id="people-details-popup-body">
        <AdminMemberDetails
          group={group}
          activeMemberID={activeMemberID}
          key={activeMemberID}
          isPopUp={true}
          getCommunityQuery={getCommunityQuery}
        />
      </div>
    </ReactModal>
  )
}

export default AdminMemberDetailsPopUp